export enum Locale {
  enGB = 'en-GB',
  enUS = 'en-US',
  fr = 'fr',
  es = 'es',
  dev = 'dev',
}
